export interface BaseRequest {
  status: 'PENDING' | 'APPROVED' | 'DENIED'
  reviewerId: number
  requestId: number
  requesterUserId: number
  reviewer?: string
  reviewComment?: string
  actionTimestamp?: string | Date
  createdAt: string | Date
}

export interface ApprovalRequests {
  requests: Requests[]
}

export interface Requests extends BaseRequest {
  numUltimates: number
  numClients: number
  numAccounts: number
  actionType: string
  accountIds: number[]
  requestedBy: string
  reporter: string
  reconDate: string
  missingExternalPosErrCount?: number
  highRiskErrCount?: number
  otherErrCount?: number
  totalErrors?: number
  comment: string
  expiryTime: string
  lastReconRunDate: string | 'Multiple' | Date
  tradingDataFeedCount?: number
  custodyDataFeedCount?: number
  totalCommands?: number
  restrictedCommands?: number
}

export interface RequestDetail extends BaseRequest {
  accountId: number
  clientId: number
  ultimateParentId?: number
  actionType: string
  requestedBy: string
  reporter: string
  reconDate: string
  missingExternalPosErrCount: number
  highRiskErrCount: number
  otherErrCount: number
  totalErrors: number
  comment: string
  expiryTime: string
  lastReconRunDate: string
  tradingDataFeeds?: string
  custodyDataFeeds?: string
}

export interface RestrictedBreakDetail extends BaseRequest {
  accountId: number
  clientId: number
  ultimateParentId?: number
  actionType: string
  requestedBy: string
  reconDate: string
  breakType: string
  assetId: string
  breakId: string
  comment: string
}

export interface RequestUpdates {
  requestId: number
  accountIds?: number[]
}

export interface RestrictedActionStatusUpdateRequest {
  requestUpdates: RequestUpdates[]
  newStatus: RequestStatus
  reviewComment?: string
  reviewerId: number
}

export enum RequestStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
}

export interface RequestUpdateResponse {
  errorMessage?: string
  accountIdsToJobs?: []
}
